import { orchestratorV1BaseUrl } from '../../api/orchestratorAuth';
import { buildOrchestratorOperatorStartUrl } from './orchestratorChainCore';

/** Runtime side of the chained orchestrator sign-in (see orchestratorChainCore.ts). */

const LAST_ATTEMPT_KEY = 'c4y.admin.oidc.orchestratorChainAt';

// Module state = "this page load".
let attemptedThisPageLoad = false;

export function orchestratorChainAttemptedThisPageLoad(): boolean {
  return attemptedThisPageLoad;
}

export function lastOrchestratorChainAt(): number | null {
  try {
    const raw = window.sessionStorage.getItem(LAST_ATTEMPT_KEY);
    const n = raw ? Number(raw) : NaN;
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

/** Top-level navigation to the orchestrator operator OAuth start; comes back to the current URL. */
export function startOrchestratorOperatorChain(): void {
  attemptedThisPageLoad = true;
  try {
    window.sessionStorage.setItem(LAST_ATTEMPT_KEY, String(Date.now()));
  } catch {
    /* without storage the per-page-load guard still holds */
  }
  window.location.assign(buildOrchestratorOperatorStartUrl(orchestratorV1BaseUrl(), window.location.href));
}

export function clearOrchestratorChainGuard(): void {
  attemptedThisPageLoad = false;
  try {
    window.sessionStorage.removeItem(LAST_ATTEMPT_KEY);
  } catch {
    /* ignore */
  }
}
